import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  matchRoutes,
} from "react-router-dom";

import PrivateRoute from "./Utils/PrivateRoute";
import PublicRoute from "./Utils/PublicRoute";
import AdminRoute from "./Utils/AdminRoute";
import { getToken, getUser } from "./Utils/Common";

import Login from "./pages/login";
import Signup from "./pages/signup";
import Home from "./pages/home";
import Dashboard from "./pages/dashboard";
import ForgetPage from "./pages/resetpass";
import Resetpass from "./pages/forgetpass";
import Profile from "./pages/profile";
import Checkout from "./pages/checkout";
import Subs from "./pages/subs";

import AdminDashboard from "./pages/admin/dashboard";
import CreateBook from "./pages/admin/books/create-book";
// import ChapterList from "./pages/admin/chapter/list";
import AllChapter from "./pages/admin/chapter/list";
import AddChapter from "./pages/admin/chapter/create";
import Table from "./pages/admin/chapter/tables";
import CreatePhrase from "./pages/admin/chapter/phrase/create";
import XLayout from "./components/layout/xLayout";
import PhraseList from "./pages/admin/chapter/phrase/list";
import BookList from "./pages/admin/books/booklist";
import EditBook from "./pages/admin/books/edit";
import EditChapter from "./pages/admin/chapter/edit";
import BookDetailAdmin from "./pages/admin/books/book-detail";

import LingonovelStory from "./pages/guest/lingostory";
import Ling from "./pages/guest/ling";
import New from "./pages/guest/new";
import BookDetail from "./pages/guest/book-detail";

import EditPhrase from "./pages/admin/chapter/phrase/edit";
import TakePayment from "./pages/user/payment/create-subscription";
import Account from "./pages/user/payment/success";
import AccountDetail from "./pages/user/payment/account";
import CreatePayment from "./pages/user/payment/create-payment";
import Library from "./pages/user/library";
import PaymentSuccess from "./pages/user/payment/payment-success";
import UserLayout from "./components/layout/user/layout";
import NotFound from "./pages/not-found";
import BookRead from "./pages/user/book-read";
import Welcome from "./pages/user/welcome";
import ThanksPage from "./pages/user/thank-page";
import CancelPage from "./pages/user/payment/cancel";
import WriteReview from "./pages/user/write-review";
import CreditThanks from "./pages/user/credit-welcome";
import SampleRead from "./pages/guest/book-read";
import HomeLayout from "./components/layout/main/homelayout";
import Cancellation from "./pages/user/cancellation";
// import BKD from "./pages/guest/book-detail-v1";
// import { ReactNotifications, Store } from 'react-notifications-component';
// import 'react-notifications-component/dist/theme.css';

import MainLayout from "./components/layout/main-layout";
import Takebreak from "./pages/user/takebreak";
import Showoffer from "./pages/user/showoffer";
import CancelReason from "./pages/user/cancel-reason";
import CancelConfirm from "./pages/user/cancel-confirm";
import ChangePassword from "./pages/user/change-password";
import ContactPage from "./pages/user/contact";
import EmailSent from "./pages/user/emailsent";
import DiscountSuccess from "./pages/user/payment/discount-success";
import ConfirmPurchase from "./pages/guest/confim-purchase";
import CreditCofirm from "./pages/user/credit-confirm";
import Logout from "./pages/logout";

export default function App() {
  useEffect(() => {
    const token = getToken();
    const user = getUser();
    // console.log("app", user);
    if (!token) {
      return;
    }
  }, []);

  return (
    <>
      <BrowserRouter>
        <MainLayout />
        {/* <UserLayout /> */}
        {/* <HomeLayout /> */}
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/logout" element={<Logout />} />
          <Route exact path="/contact" element={<ContactPage />} />

          <Route exact path="/contact/email-send" element={<EmailSent />} />

          {/* <Route exact path="/home2" element={<HomeLayout />} /> */}
          <Route
            exact
            path="/subscription"
            element={
              <PrivateRoute>
                <TakePayment />
              </PrivateRoute>
            }
          />
          {/* <Route
            exact
            path="/contact"
            element={
              <PublicRoute>
                <ContactPage />
              </PublicRoute>
            }
          />

          <Route
            exact
            path="/contact/email-send"
            element={
              <PublicRoute>
                <EmailSent />
              </PublicRoute>
            }
          /> */}

          <Route
            exact
            path="/cancel"
            element={
              <PrivateRoute>
                <CancelPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/credit-thanks"
            element={
              <PrivateRoute>
                <CreditThanks />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/library"
            element={
              <PrivateRoute>
                <Library />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/user/thanks"
            element={
              <PrivateRoute>
                <ThanksPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/library/:book_code/read"
            element={
              <PrivateRoute>
                <BookRead />
              </PrivateRoute>
            }
          />
          {/* <Route
            exact
            path="/library/:book_code&:phrase_no"
            element={
              <PrivateRoute>
                <ReadNext />
              </PrivateRoute>
            }
          /> */}
          <Route
            exact
            path="/user/welcome"
            element={
              <PrivateRoute>
                <Welcome />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/buy"
            element={
              <PrivateRoute>
                <CreatePayment />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/buy/confirm-purchase"
            element={
              <PrivateRoute>
                <CreditCofirm />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/confirm-purchase/:book_code"
            element={
              <PrivateRoute>
                <ConfirmPurchase />
              </PrivateRoute>
              // <PublicRoute>
              //   <ConfirmPurchase />
              // </PublicRoute>
            }
          />

          <Route
            exact
            path="/library/:book_code/write-a-review"
            element={
              <PrivateRoute>
                <WriteReview />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/success/:id"
            element={
              <PrivateRoute>
                <Account />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/payment-success/:id"
            element={
              <PrivateRoute>
                <PaymentSuccess />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/cancel/:id"
            element={
              <PrivateRoute>
                <Account />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/account"
            element={
              <PrivateRoute>
                <AccountDetail />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/account/cancellation"
            element={
              <PrivateRoute>
                <Cancellation />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/account/takebreak"
            element={
              <PrivateRoute>
                <Takebreak />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/account/cancellation/showoffer"
            element={
              <PrivateRoute>
                <Showoffer />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/discount-success/:id"
            element={
              <PrivateRoute>
                <DiscountSuccess />
              </PrivateRoute>
            }
          />

          <Route
            exacte
            path="/account/cancellation/reason"
            element={
              <PrivateRoute>
                <CancelReason />
              </PrivateRoute>
            }
          />
          <Route
            exacte
            path="/account/cancellation/confirm"
            element={
              <PrivateRoute>
                <CancelConfirm />
              </PrivateRoute>
            }
          />
          <Route
            exacte
            path="/account/change-password"
            element={
              <PrivateRoute>
                <ChangePassword />
              </PrivateRoute>
            }
          />
          <Route exact path="/lingonovel-story" element={<LingonovelStory />} />
          <Route
            exact
            path="/book-detail/:book_code"
            element={<BookDetail />}
          />
          <Route exact path="/guest/:book_code/read" element={<SampleRead />} />
          <Route exact path="/ling" element={<Ling />} />
          <Route exact path="/lingostory" element={<New />} />
          <Route exact path="/subs" element={<Subs />} />
          <Route
            exact
            path="/admin/dashboard/create-book"
            element={
              <AdminRoute>
                {" "}
                <CreateBook />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/admin/books/edit/:book_code"
            element={
              <AdminRoute>
                {" "}
                <EditBook />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/admin/book-detail/:book_code"
            element={
              <AdminRoute>
                {" "}
                <BookDetailAdmin />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/admin/chapters/edit/:id"
            element={
              <AdminRoute>
                {" "}
                <EditChapter />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/admin/phrases/edit/:id"
            element={
              <AdminRoute>
                {" "}
                <EditPhrase />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/admin/dashboard/table"
            element={
              <AdminRoute>
                {" "}
                <Table />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/admin/chapter/phrase/create/:chapter_id"
            element={
              <AdminRoute>
                {" "}
                <CreatePhrase />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/admin/books"
            element={
              <AdminRoute>
                {" "}
                <BookList />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/admin/chapter/phrase/list/:chapter_id"
            element={
              <AdminRoute>
                {" "}
                <PhraseList />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/admin/books/chapter/create/:book_id"
            element={
              <AdminRoute>
                <AddChapter />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/admin/chapter/list/:book_id"
            element={
              <AdminRoute>
                <AllChapter />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            exact
            path="/resetpassword"
            element={
              <PublicRoute>
                <ForgetPage />
              </PublicRoute>
            }
          />
          <Route
            exact
            path="/forgot"
            element={
              <PublicRoute>
                <Resetpass />
              </PublicRoute>
            }
          />
          {/* <Route
            exact
            path="/payment"
            element={
              <PublicRoute>
                <Subscription />
              </PublicRoute>
            }
          /> */}
          <Route
            exact
            path="/signup"
            element={
              <PublicRoute>
                <Signup />
              </PublicRoute>
            }
          />
          <Route
            exact
            path="/admin/dashboard"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
          <Route
            exact
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/profile"
            element={
              <PublicRoute>
                <Profile />
              </PublicRoute>
            }
          />
          {/* <Route
            exact
            path="/check"
            element={
              <PublicRoute>
                <Checkout />
              </PublicRoute>
            }
          /> */}
          {/* <Route
            exact
            path="/checkout"
            element={
              clientSecret && (
                <PublicRoute>
                  <Elements options={options} stripe={stripePromise}>
                    <CheckoutForm />
                  </Elements>
                </PublicRoute>
              )
            }
          /> */}
          {/* <Route
          exact
          path="/signup"
          element={
            <PublicRoute>
              <Signup />
            </PublicRoute>
          }
        />

        <Route
          exact
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
       */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>

      {/* <Elements options={options} stripe={stripePromise}>
        <CheckoutForm />
      </Elements> */}
    </>
  );
}
